import { Component, Input, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InterfaceJob } from 'app/models/job.model';
import { EmployeeService } from 'app/services/employee.service';
import { timezone } from 'assets/constants/timezone';
import { Observable, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezoneDayJs from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezoneDayJs);

@Component({
  selector: 'app-create-functions',
  templateUrl: './create-functions.component.html',
  styleUrls: ['./create-functions.component.scss']
})
export class CreateFunctionsComponent implements OnInit {

  @Input() job: InterfaceJob;
  isSaving = false;
  functionForm: FormGroup;
  userId: string;
  userName: string;
  currentPercentage = 0;
  subscriptions: Subscription[] = [];
  isUploadingFile = false;
  downloadURL: Observable<string> = new Observable;

  constructor(
    public ngbActiveModal: NgbActiveModal,
    protected fb: FormBuilder,
    protected employeeService: EmployeeService,
    protected storage: AngularFireStorage
  ) {
    this.functionForm = this.fb.group({
      checkPoint: [null, Validators.required],
      priority: [null, Validators.required],
      period: [null, Validators.required],
      supervisorPeriod: [null, Validators.required],
      auditorPeriod: [null, Validators.required],
      url: [null, Validators.required]
    });
    this.userName = localStorage.getItem('userName') || 'Not found user';
    this.userId = localStorage.getItem('userId') || 'Not found user';
  }

  ngOnInit(): void {
  }

  uploadFile(target: any): void {
    let fileUploadSub: Subscription;
    this.isUploadingFile = true;
    this.currentPercentage = 0;
    // getting the file uploaded
    const file = target.files[0];
    // creating the path for the storage
    const filePath = `Jobs/CheckPoints/${this.job.id}/${Date.now()}`;
    // reference to storage
    const fileRef = this.storage.ref(filePath);
    // object to upload the file
    const task = this.storage.upload(filePath, file);
    fileUploadSub = task.percentageChanges().subscribe((percentage: any) => {
      this.currentPercentage = percentage;
    }, (error: any) => {
      console.error(error);
    });
    // checking status of the upload
    this.subscriptions.push(
      task.snapshotChanges().pipe(
        finalize(() => {
          this.downloadURL = fileRef.getDownloadURL();
          this.subscriptions.push(
            // getting the url to download
            this.downloadURL.subscribe(url => {
              if (url) {
                fileUploadSub.unsubscribe();
                this.functionForm.controls.url.patchValue(url);
                this.functionForm.controls.url.updateValueAndValidity();
                this.isUploadingFile = false;
              }
            }, (error: any) => {
              console.error(error);
            })
          );
        })
      ).subscribe((subscribeResult: any) => {
        console.log(subscribeResult);
      }, (error: any) => {
        console.error(error);
      })
    );
  }

  downloadFile(): void {
    window.open(this.functionForm.value.url);
  }

  save(): void {
    this.isSaving = true;
    const newFunction = {
      ...this.functionForm.value,
      createdAt: dayjs().tz(timezone).unix(),
      createdById: this.userId,
      createdByName: this.userName,
      id: this.employeeService.createId(),
      jobId: this.job.id,
      jobName: this.job.name
    }
    this.employeeService.createCheckPoint(newFunction).then((result: any) => {
      this.ngbActiveModal.close({
        success: true,
        result
      });
    }).catch((error: any) => {
      console.error(error);
      this.ngbActiveModal.close({
        success: false,
        error
      });
    });
  }

}
